import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject;

import { AssignmentStatusComponent, getTranslatedStatusName } from '../../utils';
import { styled } from '@xstyled/styled-components';
import { EyeOutlined } from '@ant-design/icons';
import { Button, Tooltip } from 'antd';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var StyledResultRow = styled.span(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n"])));
export var renderColumns = function renderColumns(_ref) {
  var attendeeTranslation = _ref.attendeeTranslation,
      onOpenAttendeeSubmission = _ref.onOpenAttendeeSubmission;
  return [{
    width: '6%',
    title: attendeeTranslation.order,
    dataIndex: 'order',
    key: 'order',
    render: function render(_, record) {
      var _record$report;

      return /*#__PURE__*/_jsx("span", {
        children: (_record$report = record.report) === null || _record$report === void 0 ? void 0 : _record$report.score
      });
    }
  }, {
    width: '27%',
    title: attendeeTranslation.fullName,
    key: 'lastName',
    render: function render(_, record) {
      return /*#__PURE__*/_jsxs("span", {
        children: [record.firstName, " ", record.lastName]
      });
    }
  }, {
    width: '27%',
    title: 'Email',
    dataIndex: 'email',
    key: 'email',
    render: function render(_, record) {
      return /*#__PURE__*/_jsx("span", {
        children: record.email
      });
    }
  }, {
    width: '23%',
    title: attendeeTranslation.numberOfDoingAssignment,
    key: 'numberOfDoingAssignment',
    render: function render(_, record) {
      var _record$report2;

      return /*#__PURE__*/_jsx("span", {
        children: ((_record$report2 = record.report) === null || _record$report2 === void 0 ? void 0 : _record$report2.totalSubmittedSubmission) || 0
      });
    }
  }, {
    width: '17%',
    title: attendeeTranslation.result,
    key: 'result',
    render: function render(_, record) {
      var _record$report3, _record$report$status, _record$report$status2;

      return /*#__PURE__*/_jsx(_Fragment, {
        children: /*#__PURE__*/_jsx(StyledResultRow, {
          children: (_record$report3 = record.report) !== null && _record$report3 !== void 0 && _record$report3.status ? /*#__PURE__*/_jsx(AssignmentStatusComponent, {
            statusType: (_record$report$status = record.report.status) === null || _record$report$status === void 0 ? void 0 : _record$report$status.id,
            text: getTranslatedStatusName((_record$report$status2 = record.report.status) === null || _record$report$status2 === void 0 ? void 0 : _record$report$status2.id, attendeeTranslation)
          }) : '-'
        })
      });
    }
  }, {
    render: function render(_, record) {
      return /*#__PURE__*/_jsx(Tooltip, {
        title: attendeeTranslation.clickToViewDetail,
        children: /*#__PURE__*/_jsx(Button, {
          type: "text",
          onClick: function onClick() {
            return onOpenAttendeeSubmission(record);
          },
          children: /*#__PURE__*/_jsx(EyeOutlined, {})
        })
      });
    }
  }];
};